import { DashboardModuleListItem } from '@domain-group/suit-theme'

interface NodePropertyListItemProps {
  nodeProperty: {
    name: string,
    value: string,
  },
}

const NodePropertyListItem = (props: NodePropertyListItemProps) => {
  const { nodeProperty } = props
  const { name, value } = nodeProperty || {}

  return (
    <DashboardModuleListItem
      title={name}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {value}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default NodePropertyListItem
